export default __webpack_public_path__ + "static/media/ic_cart_active_cake.db0dbdc2.svg";